exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".content > .name {\n  color: blue;\n}\n", ""]);

